import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";

import type { ListarEmpresasResponse } from "../../model/listarEmpresasResponse";

import ListCard from "../ListCard";

type EmpresasCardPropsContent = {
	data: ListarEmpresasResponse;
	skeleton?: never;
};

type EmpresasCardPropsSkeleton = {
	data?: never;
	skeleton: true;
};

type EmpresasCardProps = EmpresasCardPropsContent | EmpresasCardPropsSkeleton;

export default function EmpresasCard(props: EmpresasCardProps) {
	const navigate = useNavigate();

	function handleClick() {
		if (!props.skeleton && props.data) {
			navigate("/empresaFormulario/" + props.data.id);
		}
	}

	let skeletonButton = "";
	if (props.skeleton) {
		skeletonButton = "skeleton skeleton-button";
	}

	return (
		<>
			<ListCard onClick={handleClick}>
				<ListCard.Content>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Razão Social</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.razaoSocial ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Nome Fantasia</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.nomeFantasia ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>CNPJ</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.cnpj ?? "..."}</ListCard.Text>
					</ListCard.Item>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Telefone</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.telefone ?? "..."}</ListCard.Text>
					</ListCard.Item>
				</ListCard.Content>
				<ListCard.Action>
					<Icon path={mdiChevronRight} size={1} className={`text-muted m-2 ${skeletonButton}`} />
				</ListCard.Action>
			</ListCard>
		</>
	);
}
